module.exports = __webpack_public_path__ + "img/youtube-viewer-mini.c638a8b3.svg";